import { render, staticRenderFns } from "./comm-attend.vue?vue&type=template&id=3e5564c6&"
import script from "./comm-attend.vue?vue&type=script&lang=js&"
export * from "./comm-attend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports